module.exports = __webpack_public_path__ + "media/images/sp/brands/aqua/store_omiya-fa996dd9e742f21fbaf12766dcb56c12.jpg";